import { render, staticRenderFns } from "./form-checkbox.vue?vue&type=template&id=5345728e&scoped=true&"
import script from "./form-checkbox.vue?vue&type=script&lang=js&"
export * from "./form-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./form-checkbox.vue?vue&type=style&index=0&id=5345728e&prod&scoped=true&lang=less&"
import style1 from "./form-checkbox.vue?vue&type=style&index=1&id=5345728e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5345728e",
  null
  
)

export default component.exports